module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.newUser
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New User")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-condensed"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.first_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.last_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.user_level))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.last_login))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.api_key))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-fw fa-pencil icon-button",
      on: {
        "click": function($event) {
          _vm.editUser(user)
        }
      }
    })])])
  }))]), _vm._v(" "), _c('ModalDialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDialog.visible),
      expression: "userDialog.visible"
    }],
    attrs: {
      "title": "Edit User",
      "modal-visible": _vm.userDialog.visible,
      "confirm-button-text": "Save"
    },
    on: {
      "closeModal": function($event) {
        _vm.userDialog.visible = false
      },
      "confirm": _vm.submitUser
    }
  }, [(_vm.userDialog.newUser) ? _c('p', [_vm._v("\n\t\t\tThe user will be emailed a welcome email with their login details.\n\t\t")]) : _vm._e(), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "Username",
      "col-class": "col-md-3"
    }
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.userDialog.fields.username))])]), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "First Name",
      "col-class": "col-md-3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDialog.fields.first_name),
      expression: "userDialog.fields.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "first_name"
    },
    domProps: {
      "value": (_vm.userDialog.fields.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userDialog.fields.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "Last Name",
      "col-class": "col-md-3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDialog.fields.last_name),
      expression: "userDialog.fields.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "last_name"
    },
    domProps: {
      "value": (_vm.userDialog.fields.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userDialog.fields.last_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "Email",
      "col-class": "col-md-3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDialog.fields.email),
      expression: "userDialog.fields.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.userDialog.fields.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userDialog.fields.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "Permission",
      "col-class": "col-md-3"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDialog.fields.user_level),
      expression: "userDialog.fields.user_level"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "user_level"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDialog.fields.user_level = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")]), _vm._v(" "), _c('option', [_vm._v("Suspended")])])]), _vm._v(" "), (!_vm.userDialog.newUser) ? _c('FormGroup', {
    attrs: {
      "label": "API Key",
      "col-class": "col-md-3"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDialog.fields.api_key != ''),
      expression: "userDialog.fields.api_key != ''"
    }],
    staticClass: "form-control-static",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(_vm._s(_vm.userDialog.fields.api_key))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.genNewAPIKey(_vm.userDialog.fields.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Generate New API Key")])]) : _vm._e(), _vm._v(" "), (_vm.userDialog.alert.visible) ? _c('div', {
    staticClass: "alert",
    class: _vm.userDialog.alert.class
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.userDialog.alert.msg) + "\n\t\t\t"), _vm._l((_vm.userDialog.alert.errors), function(error) {
    return (_vm.userDialog.alert.hasErrors) ? _c('p', [_vm._v("\n\t\t\t\t" + _vm._s(error) + "\n\t\t\t")]) : _vm._e()
  })], 2) : _vm._e()], 1), _vm._v(" "), (_vm.confirmDialog.visible) ? _c('ModalDialog', {
    attrs: {
      "title": _vm.confirmDialog.title,
      "modal-visible": _vm.confirmDialog.visible,
      "confirm-button-text": _vm.confirmDialog.buttonText
    },
    on: {
      "confirm": function($event) {
        _vm.confirmationDialogResponse(true)
      },
      "closeModal": function($event) {
        _vm.confirmationDialogResponse(false)
      }
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.confirmDialog.message) + "\n\t")]) : _vm._e(), _vm._v(" "), _c('spinner', {
    attrs: {
      "spinner-visible": _vm.spinnerVisible
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Last Name")]), _vm._v(" "), _c('th', [_vm._v("Username")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Permissions")]), _vm._v(" "), _c('th', [_vm._v("Last Login")]), _vm._v(" "), _c('th', [_vm._v("API Key")]), _vm._v(" "), _c('th', {
    staticClass: "btn-col"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39dea9c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/UserManager.vue
// module id = 161
// module chunks = 1